import ApplicationCooLayout from '../../../layout/application-coo-layout';
import { TextSubheader } from '../../../components/text/text-subheader';
import { P2Button } from 'react-bootstrap-common-script';
import { useNavigate } from 'react-router-dom';
import { useInitialWindowScrollTo } from '../../../hooks/use-initial-window-scroll-to';
import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/hook';

const StageDValuationFeeUnsuccessful = () => {
  useInitialWindowScrollTo();
  const navigate = useNavigate();
  const applicationId = useAppSelector((state) => state.app.ApplicationIdSlice.applicationId);
  const queryParameters = new URLSearchParams(window.location.search);
  const applicationIdParam = queryParameters.get('application_id');

  const applicationUuid = useMemo(() => applicationIdParam ?? applicationId ?? '', [applicationIdParam, applicationId]);

  return (
    <ApplicationCooLayout>
      <div className='view-application-stage-d-container'>
        <TextSubheader subheaderMain='Payment unsuccessful' subheaderSub='Valuation fee' />
        <p className='mt-4'>Your payment was not completed. You can try again from the Stage D application page.</p>
        <P2Button
          variant='primary'
          className='mt-3'
          onClick={() => navigate(`/application-coo/stage-d/in-principle-approval?application_id=${applicationUuid}`)}>
          Back to application
        </P2Button>
      </div>
    </ApplicationCooLayout>
  );
};

export default StageDValuationFeeUnsuccessful;
